import React from 'react';
import {
  IconAlertCircle,
  IconBan,
  IconCalendarDue,
  IconCalendarX,
  IconCircleCheck,
  IconCircleMinus,
  IconClockExclamation
} from '@tabler/icons-react';
import { cn } from '@/lib/utils';

const STYLES = {
  active: ['Attivo', 'bg-blue-50 text-blue-700 border-blue-200', IconCircleCheck],
  inactive: ['Disattivato', 'bg-slate-100 text-slate-600 border-slate-200', IconBan],
  ok: ['Conforme', 'bg-green-50 text-green-700 border-green-200', IconCircleCheck],
  compliant: ['Conforme', 'bg-green-50 text-green-700 border-green-200', IconCircleCheck],
  completed: ['Completato', 'bg-green-50 text-green-700 border-green-200', IconCircleCheck],
  pending: ['Da verificare', 'bg-amber-50 text-amber-800 border-amber-200', IconClockExclamation],
  to_verify: ['Da verificare', 'bg-amber-50 text-amber-800 border-amber-200', IconClockExclamation],
  warning: ['Da verificare', 'bg-amber-50 text-amber-800 border-amber-200', IconClockExclamation],
  expiring: ['In scadenza', 'bg-amber-50 text-amber-800 border-amber-200', IconCalendarDue],
  in_expiry: ['In scadenza', 'bg-amber-50 text-amber-800 border-amber-200', IconCalendarDue],
  non_compliant: ['Non conforme', 'bg-red-50 text-red-700 border-red-200', IconAlertCircle],
  blocked: ['Bloccato', 'bg-red-100 text-red-900 border-red-300', IconBan],
  expired: ['Scaduto', 'bg-red-50 text-red-700 border-red-200', IconCalendarX],
  depleted: ['Esaurito', 'bg-slate-100 text-slate-600 border-slate-200', IconCircleMinus],
  deleted: ['Disattivato', 'bg-slate-100 text-slate-600 border-slate-200', IconBan],
  skipped: ['Saltato', 'bg-slate-100 text-slate-600 border-slate-200', IconCircleMinus],
  substituted: ['Sostituito', 'bg-amber-50 text-amber-800 border-amber-200', IconClockExclamation]
};

export default function StatusBadge({ status, label, className, showIcon = true }) {
  const [defaultLabel, style, Icon] = STYLES[status] || [status || '—', 'bg-slate-50 text-slate-600 border-slate-200', IconCircleMinus];
  return (
    <span className={cn('inline-flex min-h-7 items-center gap-1.5 rounded-md border px-2 py-1 text-xs font-semibold', style, className)}>
      {showIcon && <Icon className="h-4 w-4 shrink-0" stroke={1.75} aria-hidden="true" />}
      <span>{label || defaultLabel}</span>
    </span>
  );
}
